var $5b807d2c6052d8dd$exports = {};
$5b807d2c6052d8dd$exports = {
    "breadcrumbs": `Lingiread`
};


export {$5b807d2c6052d8dd$exports as default};
//# sourceMappingURL=et-EE.mjs.map
